import * as React from "react";
import { FGMaskInput } from "nsitools-react";

export interface IFGNumberMaskInputProps {
  name: string;
  label: string;
}

export const FGNumberMaskInput: React.FunctionComponent<IFGNumberMaskInputProps> = ({ label, name }) => {
  return (
    <FGMaskInput
      cleaveOptions={{
        numericOnly: true,
      }}
      name={name}
      label={label}
    />
  );
};
